export default {
  "b2b.provozni-informace-detail.description-label.created": "Created",
  "b2b.provozni-informace-detail.description-label.edited": "Last updated",
  "b2b.provozni-informace-detail.header-action.edit": "EDIT",
  "b2b.provozni-informace-detail.emptyMessage":
    "No operational information found"
};
